var map = {
	"./carbon-emissions.svg": "9d5c",
	"./cars.svg": "ff2b",
	"./employment.svg": "116a",
	"./gini-coefficient.svg": "f176",
	"./housing.svg": "db4c",
	"./inhabitants.svg": "d784a",
	"./map-panel-location-icon.svg": "040c",
	"./motorbikes.svg": "2a3f",
	"./poverty.svg": "b7b9",
	"./transport.svg": "4c1c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "766f";